<template>
  <div id="app">
    <Notification
        v-if="notificationMessage"
        :message="notificationMessage"
        :type="notificationType"
        :duration="notificationDuration"
        @closed="notificationMessage = null"
    />
    <BurgerMenu :isOpen="isOpen" @toggleMenu="toggleMenu"/>

    <Navbar :isOpen="isOpen" @toggleMenu="toggleMenu"/>
    <Loader :visible="isFirstLoad"/>

    <div class="app-container container-fluid">
      <router-view @set-loading="setLoading"/>
    </div>

    <BottomNav/>
<!--    <Footer/>-->
    <div id="modal-container"></div>
  </div>
</template>

<script>
import Navbar from "./components/app/nav/top/Navbar.vue";
import Tutorial from "./components/app/tutorials/Tutorial.vue";
import TutorialsList from "./components/app/tutorials/TutorialsList.vue";
import BottomNav from "./components/app/nav/bottom/BottomNav.vue";
import BurgerMenu from "./components/app/nav/top/BurgerMenu.vue";
import Footer from "./components/app/Footer.vue";
import Loader from "./components/app/Loader.vue";
import Notification from "./components/app/Notification.vue";
import { notificationMixin } from './mixins/notificationMixin'

export default {
  name: 'App',
  components: {Notification, Loader, Footer, BurgerMenu, BottomNav, Navbar, TutorialsList, Tutorial},
  mixins: [notificationMixin],

  data() {
    return {
      isOpen: false,
      isFirstLoad: false,
      notificationMessage: null,
      notificationType: "info",
    };
  },


  methods: {

    toggleMenu() {
      this.isOpen = !this.isOpen; // Переключаем состояние меню
    },
    setLoading(isLoading) {
      this.isFirstLoad = isLoading;
    },
  },
};
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.app-container {
  flex: 1;
  padding: 40px 0;
}

footer {
  margin-top: auto;
}

/* Стили для модальных окон */
body.modal-open {
  overflow: hidden;
  padding-right: 15px; /* Компенсация скроллбара */
  position: fixed; /* предотвращаем прокрутку body */
  width: 100%;
}

#modal-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

#modal-container > * {
  pointer-events: auto;
}
</style>

